/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_Placeholder_InstructionsInputs */



/**
* | output |
* | --- |
* | "Define how AI should behave in this project..." |
*
* @param {Create_Project_Placeholder_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_placeholder_instructions = /** @type {((inputs?: Create_Project_Placeholder_InstructionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Placeholder_InstructionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Definiere, wie sich die KI in diesem Projekt verhalten soll...")
	return /** @type {LocalizedString} */ ("Define how AI should behave in this project...")
});